<template>
    <div>

        <div class="smallContent miscContent" :class="{ mobile: $mq == 'sm' }">
            <p v-if="!store.authenticated && $mq != 'sm'">
                Login
            </p>


            <form @submit.prevent="login" v-if="!store.authenticated">
                <input type="text" v-model="username" placeholder="Username" required /><br>
                <input type="password" v-model="password" placeholder="Password" required /><br>
                <input type="submit" value="Login" />
            </form>

            <div>
                <p v-if="message" id="message" :class="{ error: error }">{{ message }}</p>
            </div>

            <div v-if="!store.authenticated">
                <div id="forgot">
                    <router-link :to="{ name: 'resetPW' }">Forgot Password</router-link>
                </div>
                <div id="text">
                    Don’t have an account yet? Become a MPR Supporter and listen to our entire archive in your private
                    player.
                </div>
                <router-link id="support" :to="{ name: 'subscribe' }">Support Montez Press Radio</router-link>
            </div>



            </form>
        </div>


        <Footer></Footer>
    </div>
</template>


<script>
import axios from 'axios';
import { store } from '../store'
import { DateTime, Interval } from 'luxon';
import Footer from "./Footer.vue";

export default {
    name: 'Login',
    components: {
        Footer,
    },
    data() {
        return {
            password: '',
            username: '',
            store: store,
            message: '',
            error: false,
        }
    },
    methods: {
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);

                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);

                }

            }
            return "";

        },
        login() {
            let myself = this;
            myself.message = '';
            axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrftoken');
            axios.post('/api/login', { 'username': this.username, 'password': this.password })
                .then(response => {
                    if (response.data.detail == 'Success') {
                        localStorage.setItem("authenticated", "success");
                        localStorage.setItem("giftEligible", response.data.gift_eligible);
                        localStorage.setItem("userID", response.data.user_id);
                        localStorage.setItem("confirmed", response.data.confirmed);
                        localStorage.setItem("likes", JSON.stringify(response.data.likes));
                        myself.store.giftEligible = response.data.gift_eligible;
                        myself.store.userID = response.data.user_id;
                        myself.store.authenticated = true;
                        myself.store.confirmed = response.data.confirmed;
                        myself.store.likes = response.data.likes;
                        if (response.data.account_active) {
                            myself.store.lastPayed = response.data.last_payed;
                            myself.store.accountActive = response.data.account_active;
                            localStorage.setItem("lastPayed", response.data.last_payed);
                            localStorage.setItem("accountActive", response.data.account_active);
                            //let now = DateTime.utc()
                            //let payed = DateTime.fromISO(response.data.last_payed)
                            //let interval = Interval.fromDateTimes(payed, now)
                            //if (interval.length('days') > myself.store.expireTime){
                            //myself.store.showSubExpiredPopup = true
                            //} else if (interval.length('days') > myself.store.expireWarning){
                            //myself.store.showSubWarnPopup = true
                            //myself.store.valid = true;
                            //} else {
                            //myself.store.valid = true;
                            //}
                            myself.store.valid = true;
                        }
                        myself.error = false;
                    } else {
                        myself.error = true;
                    }
                    myself.message = response.data.message
                })
        }

    },
    created() {
        axios.get("/api/login-set-cookie");
    },
    activated() {
        this.message = '';
        this.hash = '';
        this.error = false;
    },

}

</script>


<style scoped>
.smallContent.mobile {
    margin-top: 0.5rem;
}

p {
    margin-bottom: 1.7rem;
    margin-top: 0;
}

#forgot a {
    color: #aaaaaa;
    text-align: center;
    display: block;
    margin: 1.7rem 0 1.4rem;
}

#forgot a:hover {
    color: black;
}

#text {}

#support {
    margin-top: 1rem;
    width: 100%;
    border: 1px solid black;
    padding: 0.65rem 1rem 0.85rem;
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
}

#support:hover {
    background-color: black;
    color: white;

}

#message {
    margin-top: 1rem;
}

#message.error {
    color: red;
}

.miscContent {
    width: min(550px, 100%);
}
</style>
